import { useEffect, useCallback } from 'react'
import { socketClient } from '../services'

/**
 * Хук для работы с WebSocket соединением
 */
export const useSocket = () => {
    // Socket подключается в App.js при аутентификации
    // Здесь только предоставляем API для работы с ним

    const on = useCallback((event, callback) => {
        socketClient.on(event, callback)

        return () => socketClient.off(event, callback)
    }, [])

    const emit = useCallback((event, data) => {
        socketClient.send(event, data)
    }, [])

    return {
        on,
        emit,
        isConnected: socketClient.isSocketConnected(),
        joinBattle: socketClient.joinBattle.bind(socketClient),
        leaveBattle: socketClient.leaveBattle.bind(socketClient),
        ping: socketClient.ping.bind(socketClient),
        updateStatus: socketClient.updateStatus.bind(socketClient),
        getOnlineUsers: socketClient.getOnlineUsers.bind(socketClient),
    }
}

/**
 * Хук для уведомлений через WebSocket
 */
export const useSocketNotifications = (onNotification) => {
    const { on } = useSocket()

    useEffect(() => {
        if (onNotification) {
            const unsubscribe = on('notification', onNotification)
            return unsubscribe
        }
    }, [on, onNotification])
}

/**
 * Хук для битв через WebSocket
 */
export const useBattleSocket = (callbacks = {}) => {
    const { on, joinBattle, leaveBattle } = useSocket()

    useEffect(() => {
        const unsubscribers = []

        if (callbacks.onBattleStarted) {
            unsubscribers.push(on('battle_started', callbacks.onBattleStarted))
        }

        if (callbacks.onBattleFinished) {
            unsubscribers.push(
                on('battle_finished', callbacks.onBattleFinished)
            )
        }

        return () => {
            unsubscribers.forEach((unsubscribe) => unsubscribe())
        }
    }, [on, callbacks])

    return {
        joinBattle,
        leaveBattle,
    }
}
